module.exports = __webpack_public_path__ + "img/service3.2d5fe680.webp";